import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ar-filter" }
const _hoisted_2 = { class: "sizing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "AR PHOTO FILTER", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createTextVNode(" 平井 大オフィシャルアプリ「LOSL」を "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ご利用のお客様限定で "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ARフィルターをご利用いただけます。 ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "notice" }, [
  /*#__PURE__*/_createElementVNode("p", null, "※会場内限定で公演当日20時までのご利用となります。")
], -1)
const _hoisted_6 = { class: "link" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "link-notice" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("※Android端末をご利用のお客様はアプリHOMEの"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("「THE BEACH TRIP AR PHOTO FRAME」のバナーよりご利用ください。")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("button", _hoisted_6, [
        _createElementVNode("a", {
          href: "https://pro-vision-xr.com/ar/contents/tv-asahi-music/2024/y7g6dy7viqeeh9p0dloq2n68hcwydecodllmwgq83uftp0mm11/?id=c053wt9i6tytkh1bciuxkie2bsfnehs82e8lwwykduq2hdrhx3",
          target: "_blank",
          onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, "ARフィルターはこちら", 32)
      ]),
      _hoisted_7
    ])
  ]))
}